import { render, staticRenderFns } from "./page-landing.vue?vue&type=template&id=38ca50c6&scoped=true"
import script from "./page-landing.vue?vue&type=script&lang=js"
export * from "./page-landing.vue?vue&type=script&lang=js"
import style0 from "./page-landing.vue?vue&type=style&index=0&id=38ca50c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ca50c6",
  null
  
)

export default component.exports